import { Injectable } from '@angular/core';
import { ApiDirectory } from '@core/api/api-directory';
import { RequestResponse } from '@core/services/request/model/request.model';
import { RequestService } from '@core/services/request/request.service';
import { Observable } from 'rxjs';
import {
  ClimateConsumptionApi,
  ConsumptionInvoicesFilterApi,
  DailyClimateConsumptionApi,
  HousingModelApi,
  MonthlyClimateConsumptionApi,
  RoomModelApi,
} from '../../model/consumption-invoices/consumption-invoices-api.model';
import { HttpParamsService } from '@core/services/http-params/http-params.service';
import { LoadingIds } from '@shared/constants/loading';

@Injectable({
  providedIn: 'root',
})
export class ApiClimateService {
  constructor(
    private _requestService: RequestService,
    private _httpParamsService: HttpParamsService
  ) {}

  public fetchHousingClimate(genericLoading?: boolean) {
    return this._requestService.get<RequestResponse<Array<HousingModelApi>>>(ApiDirectory.ConsumoInformes.ViviendasClimate({}), {
      loading: genericLoading ?? LoadingIds.FETCH_CLIMATE_HOUSING,
    });
  }

  public fetchRoomsClimate(genericLoading?: boolean) {
    return this._requestService.get<RequestResponse<Array<RoomModelApi>>>(ApiDirectory.ConsumoInformes.HabitacionesClimate({}), {
      loading: genericLoading ?? LoadingIds.FETCH_CLIMATE_ROOMS,
    });
  }

  public fetchDaily(filter: ConsumptionInvoicesFilterApi): Observable<RequestResponse<ClimateConsumptionApi<DailyClimateConsumptionApi>>> {
    return this._requestService.get(ApiDirectory.ConsumoInformes.ClimateDiario({}), {
      params: this._httpParamsService.toParams(filter),
      hideErrorAlert: true,
      loading: LoadingIds.FETCH_CLIMATE_CONSUMPTION,
    });
  }

  public fetchMonthly(
    filter: ConsumptionInvoicesFilterApi
  ): Observable<RequestResponse<ClimateConsumptionApi<MonthlyClimateConsumptionApi>>> {
    return this._requestService.get(ApiDirectory.ConsumoInformes.ClimateMensual({}), {
      params: this._httpParamsService.toParams(filter),
      hideErrorAlert: true,
      loading: LoadingIds.FETCH_CLIMATE_CONSUMPTION,
    });
  }

  public downloadExcelDaily(filter: ConsumptionInvoicesFilterApi) {
    return this._requestService.downloadWithProgress(ApiDirectory.ConsumoInformes.ClimateExcelDiario({}), {
      params: this._httpParamsService.toParams(filter),
    });
  }

  public downloadExcelMonthly(filter: ConsumptionInvoicesFilterApi) {
    return this._requestService.downloadWithProgress(ApiDirectory.ConsumoInformes.ClimateExcelMensual({}), {
      params: this._httpParamsService.toParams(filter),
    });
  }
}
